import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import { CurrentItem } from 'Types/selectric';
import * as $ from 'jquery';
import { Filters } from './Filters';

export class MultiselectTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    MULTISELECT: '.js_filter_multiselect',
  }

  public static init() {
  	this.initSelectricMinWidth();
    $(this.Selector.MULTISELECT).selectric({
      arrowButtonMarkup: /* html */ `<i class=\"fa fa-chevron-down\"></i>`,
      nativeOnMobile: false,
      onChange: (element) => {
        this.applyReadyToBeSubmittedClass($(element));
        let changeHappenedWithinSidePanel = $(element).parents(Filters.Selector.MORE_FILTERS_SIDE_SECTION).length > 0;

        this.syncSelectTypeFilterWithItsEquivalent(element, {
          targetSelector: changeHappenedWithinSidePanel ? Filters.Selector.NORMAL_FILTERS_SECTION : Filters.Selector.MORE_FILTERS_SIDE_SECTION
        });
      },
      labelBuilder(currentItem: CurrentItem) {
        const filterName = $(currentItem.element)
          .parent("select")
          .data("filter-name");

        const selectedOptions = $(currentItem.element).parent("select").children("option:selected");

        if (selectedOptions.length === 0) {
          return filterName;
        }

	 	const firstText = selectedOptions.first().text().trim();

	  	if (selectedOptions.length === 1) {
	  		return `<b class="text-primary ml-2">${firstText}</b>`;
        }
        return `<b class="text-primary ml-2">${firstText} + </b>`;

	  },
      multiple: {
        maxLabelEntries: 1,
        separator: "",
      },
    });
  }
}
import { SubmittableFilter } from 'Components/Filters/SubmittableFilter';
import { CurrentItem } from 'Types/selectric';
import * as $ from 'jquery';
import { Filters } from './Filters';

export class MultiselectTypeFilters extends SubmittableFilter {
  protected static readonly Selector = {
    MULTISELECT: '.js_filter_multiselect',
  }

  public static init() {
  	this.initSelectricMinWidth();
    $(this.Selector.MULTISELECT).selectric({
      arrowButtonMarkup: /* html */ `<i class=\"fa fa-chevron-down\"></i>`,
      nativeOnMobile: false,
      onChange: (element) => {
        this.applyReadyToBeSubmittedClass($(element));
        let changeHappenedWithinSidePanel = $(element).parents(Filters.Selector.MORE_FILTERS_SIDE_SECTION).length > 0;

        this.syncSelectTypeFilterWithItsEquivalent(element, {
          targetSelector: changeHappenedWithinSidePanel ? Filters.Selector.NORMAL_FILTERS_SECTION : Filters.Selector.MORE_FILTERS_SIDE_SECTION
        });
      },
      labelBuilder(currentItem: CurrentItem) {
        const filterName = $(currentItem.element)
          .parent("select")
          .data("filter-name");

        const selectedOptions = $(currentItem.element).parent("select").children("option:selected");

        if (selectedOptions.length === 0) {
          return filterName;
        }

	 	const firstText = selectedOptions.first().text().trim();

	  	if (selectedOptions.length === 1) {
	  		return `<b class="text-primary ml-2">${firstText}</b>`;
        }
        return `<b class="text-primary ml-2">${firstText} + </b>`;

	  },
      multiple: {
        maxLabelEntries: 1,
        separator: "",
      },
    });
  }
}
